var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAdmin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 10V38C38 40.2091 36.2091 42 34 42H12C12 44.2091 13.7909 46 16 46H34C38.4183 46 42 42.4183 42 38V14C42 11.7909 40.2091 10 38 10Z",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 6V34C34 36.2091 32.2091 38 30 38H8C5.79086 38 4 36.2091 4 34V15.66C3.99916 14.5939 4.42392 13.5716 5.18 12.82L14.82 3.18C15.5716 2.42392 16.5939 1.99916 17.66 2H30C32.2091 2 34 3.79086 34 6ZM16 16C17.1046 16 18 15.1046 18 14V5.64001L7.64001 16H16Z",
    fillOpacity: 0.7
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdmin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Admin.6bb1abff.svg";
export { ForwardRef as ReactComponent };